<template>
  <div class="container--small single-card">
    <div class="single-card__container">
      <video-layer :url="videoUrl" :flowid="flowid" ref="videoLayer">
        <template v-slot:closebtn>
          {{ closeText }}
        </template>
      </video-layer>

      <slot :openVideo="openVideo"/>
    </div>
  </div>
</template>

<script>
  import { tag } from '@Foundation/analyticsHandler/directives/tag.js';

  export default {
    name: 'single-card',

    components: {
      'video-layer': () => import('@Feature/Video/code/Scripts/VideoLayer/video-layer')
    },

    directives: {
      tag
    },

    props: {
      closeText: { type: String, default: 'close' }
    },

    data() {
      return {
        videoUrl: null,
        flowid: null
      };
    },

    methods: {
      openVideo(data, event) {
        const clickedElement = event.target;

        this.videoUrl = data.url;
        this.flowid = data.flowid;
        setTimeout(() => {
          this.$refs.videoLayer.videoCall(clickedElement);
        }, 100);
      },
    }
  };
</script>
